
import { all } from 'redux-saga/effects'

import { authorizationSagas } from './authorization'
import { loggerSagas } from './logger'
import { globalSettingsSagas } from './global-settings'
import { setupSagas } from  './setup'
import { counselingSessionSagas } from './counseling-session'
import { errorRedirectSagas} from './error-redirect'


export default function* rootSaga() {
  yield all([
    ...authorizationSagas,
    ...globalSettingsSagas,
    ...counselingSessionSagas,
    ...setupSagas,
    ...errorRedirectSagas,
    ...loggerSagas
  ])
}




// WEBPACK FOOTER //
// ./src/sagas/index.js